import { DefaultState } from 'store/types';

export const GET_LOCATION_DATA_REQUEST = 'GET_LOCATION_DATA_REQUEST';
export const GET_LOCATION_DATA_SUCCESS = 'GET_LOCATION_DATA_SUCCESS';
export const GET_LOCATION_DATA_FAILURE = 'GET_LOCATION_DATA_FAILURE';

export interface LocationData {
  jobID: string;
  jobOwner?: string;
  jobSupervisor?: string;
  jobSupervisorContactInformation?: string;
  startTimeOfJob?: string;
  distance?: string;
  datesScheduled?: string;
  projectName?: string;
  lodgingCost?: string;
  hotelBillablePartiallyAmount?: string;
  storeNumber?: string;
  corporateClientName?: string;
};

export type LocationDataState = DefaultState & {
  contents?: LocationData;
};

interface GetLocationDataRequest {
  type: typeof GET_LOCATION_DATA_REQUEST;
};

interface GetLocationDataSuccess {
  type: typeof GET_LOCATION_DATA_SUCCESS,
  contents: LocationData;
}

interface GetLocationDataFailure {
  type: typeof GET_LOCATION_DATA_FAILURE;
}

export type GetLocationDataActionTypes = GetLocationDataRequest | GetLocationDataSuccess | GetLocationDataFailure;